const REACT_APP_GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const REACT_APP_BACKEND_API_KEY = process.env.REACT_APP_BACKEND_API_KEY;
const validateAddress = async (address) => {
    //address will be passed in, format of address1+address2+city+state+zip
    const url = `${REACT_APP_BACKEND_URL}validate-address/${encodeURIComponent(address)}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "x-api-key": REACT_APP_BACKEND_API_KEY,
            },
            });
        const data = await response.json();
        if(data.valid) {
            console.log("valid address");
            return {valid: true, message: data.address};
        } else {
            console.log("invalid address");
            return {valid: false, message: "invalid address"};
        }
    } catch (error) {
        return {valid: false, message: `Failed with error message of: ${error}`};
    }
};

const calculateDeliveryPrice = async (address) => {
    //address will be passed in, format of address1+address2+city+state+zip
    const url = `${REACT_APP_BACKEND_URL}/calculate-distance/${encodeURIComponent(address)}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "x-api-key": REACT_APP_BACKEND_API_KEY,
            },
            });
        const data = await response.json();
        if(data.status==='success') {
            const price = data.price;
            return {status: "success", message:"successfully retrieved distance", price: price};
        } else {
            return {status: "fail", message: "unable to get distance"};
        }
    } catch (error) {
        return {valid: false, message: `Failed with error message of: ${error}`};
    }
};

const deliveryAreaCheck = async (address) => {
    const lat_top = 30.0847;
    const lat_bot = 29.5049;
    const lng_right = -95.1073;
    const lng_left = -96.4353;
    //address will be passed in, format of address1+address2+city+state+zip
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${REACT_APP_GOOGLE_API_KEY}`;

    try {
        const response = await fetch(url);
        const data = await response.json();
        if (data.status ==='OK') {
            const lat = data.results[0].geometry.location.lat;
            const lng = data.results[0].geometry.location.lng;
            if (lat<lat_top && lat>lat_bot && lng>lng_left && lng<lng_right) {
                console.log("deliverable address");
                return {valid: true, message: "deliverable"};
            }
        }
    } catch (error) {
        console.log("undeliverable address");
        return {valid: false, message: `Failed with error message of: ${error}`};
    }
    console.log("undeliverable address");
    return {valid: false, message: "undeliverable"};
};

export {deliveryAreaCheck, calculateDeliveryPrice, validateAddress};